
import Layout from '@/components/Layout/Layout.vue'
import { defineComponent } from 'vue'
export default defineComponent({
  components: {
    Layout
  }
})
